

<script>

import { mapActions } from "vuex";
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators"; // for validators
import {swal, imageError} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Post from '../../../model/post.js';
import { dataURLtoFile } from '../../../helpers/helper_func'
import appConfig from "@/app.config";
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import InputTag from 'vue-input-tag';
import VueEditor from '@/components/Vue2Editor'


export default {
  components: { AlertError, Cropper, InputTag, VueEditor },
  data() {
    return {
      // limit tag
      limit:10,

      //Page errors.
      errors: [],

      post: new Post,
      acceptFile: appConfig.acceptFile.post,
      aspectRatio: Number(appConfig.aspectRatio.post),
      submitadd: false,
      loadingButton: false,
    };
  },
  // vuelidate
  validations: {
    post: {
      title_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), minLength: minLength(2), maxLength: maxLength(300) },
      image: {required},
      locales: {required}
    },
  },
  methods: {
    ...mapActions("post", ['add']),
    imageError,
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    chnageFile(e){
      this.post.Image = e.target.files.length > 0 ? e.target.files[0] : null;
    },
    setCroppedImage(){
      const result = this.$refs.cropper.getResult();
      const data64 = result.canvas.toDataURL(this.post.image.type);
      this.post.image = dataURLtoFile(data64, this.post.image.value);
    },
    getEditorImages(){
      let images = []
      if(this.checkLocale('ar')) images = [...this.$refs.editor1.$data.images]
      if(this.checkLocale('en')) images = [...images, ...this.$refs.editor2.$data.images]
      if(this.checkLocale('fa')) images = [...images, ...this.$refs.editor3.$data.images]
      return images
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.$refs.editor1.reset()
      this.$refs.editor2.reset()
      this.$refs.editor3.reset()
      this.post.reset()
    },
    checkLocale(locale){
      return this.post.locales.includes(locale);
    },
    checkValidate(){
      return !this.$v.post.locales.$error &&
        !this.$v.post.image.$error        &&
        (!this.checkLocale('ar') || !this.$v.post.title_ar.$error) && 
        (!this.checkLocale('en') || !this.$v.post.title_en.$error) && 
        (!this.checkLocale('fa') || !this.$v.post.title_fa.$error)
    },
    formAddPost(published = false) {
      this.submitadd = true;
      this.$v.$touch();
      if(!this.checkValidate()) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.post.published = published
      this.post.editor_images = this.getEditorImages()
      this.setCroppedImage()

      this.add(this.post.toFormData())
      .then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    },
    unitTest(){
      this.post.locales = ['ar', 'en', 'fa']
      this.post.title_ar = 'test title ar'
      this.post.title_en = 'test title en'
      this.post.title_fa = 'test title fa'
      this.post.content_ar = '<h2>Test Content ar</h2>'
      this.post.content_en = '<h2>Test Content en</h2>'
      this.post.content_fa = '<h2>Test Content fa</h2>'
    },
  },
  mounted(){
    //in locale dev.
    if(process.env.NODE_ENV == "development") {
      this.unitTest()
    }
  }
};
</script>

<template>
  <b-form>

    <AlertError :errors="errors"></AlertError>

    <div class="row mt-3">
      <b-form-group class="col-md-12 mb-3" label="لغة الخبر :">
        <b-form-checkbox class="dis-inline" v-model="post.locales" value="ar" plain>عربي</b-form-checkbox>
        <b-form-checkbox class="dis-inline" v-model="post.locales" value="en" plain>انكليزي</b-form-checkbox>
        <!-- <b-form-checkbox class="dis-inline" v-model="post.locales" value="fa" plain>فارسي</b-form-checkbox> -->
        <div v-if="submitadd && $v.post.locales.$error" class="invalid-check">
          <span v-if="!$v.post.locales.required"> يجب اختيار لغة واحدة على الاقل </span>
        </div>
      </b-form-group>

      <b-form-group v-if="post.locales.includes('ar')" class="col-md-12 mb-3 class_ar" label="عنوان الخبر : ( عربي )" label-for="title_ar" >
        <b-form-input id="title_ar" v-model.trim="post.title_ar" :class="{ 'is-invalid': submitadd && $v.post.title_ar.$error }" placeholder="ادخل عنوان الخبر" type="text" ></b-form-input>
        <div v-if="submitadd && $v.post.title_ar.$error" class="invalid-feedback">
          <span v-if="!$v.post.title_ar.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.post.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.post.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="post.locales.includes('en')" class="col-md-12 mb-3 class_en" label="عنوان الخبر : ( انجليزي )" label-for="title-en" >
        <b-form-input id="title-en" v-model.trim="post.title_en" :class="{ 'is-invalid': submitadd && $v.post.title_en.$error }" placeholder="ادخل عنوان الخبر" type="text" ></b-form-input>
        <div v-if="submitadd && $v.post.title_en.$error" class="invalid-feedback">
          <span v-if="!$v.post.title_en.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.post.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.post.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="post.locales.includes('fa')" class="col-md-12 mb-3 class_fa" label="عنوان الخبر : ( فارسي )" label-for="title-fa" >
        <b-form-input id="title-fa" v-model.trim="post.title_fa" :class="{ 'is-invalid': submitadd && $v.post.title_fa.$error }" placeholder="ادخل عنوان الخبر" type="text" ></b-form-input>
        <div v-if="submitadd && $v.post.title_fa.$error" class="invalid-feedback">
          <span v-if="!$v.post.title_fa.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.post.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.post.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="صورة الخبر الرئيسية : " label-for="image" >
        <div class="custom_file">
          <b-form-file id="image" v-model="post.image" :accept="acceptFile" :class="{ 'is-invalid': submitadd && $v.post.image.$error }" @change="chnageFile" placeholder="اختر صورة" ></b-form-file>
          <div v-if="submitadd && $v.post.image.$error" class="invalid-feedback">
            <span v-if="!$v.post.image.required"> هذا الحقل الزامي </span>
          </div>
        </div>

        <cropper v-if="post.picture" :src="post.picture" @error="imageError" class="cropper" :auto-zoom="true" ref="cropper"
          :stencil-props="{ aspectRatio: aspectRatio }"
        ></cropper>
      </b-form-group>
      
      <!-- Editor -->
      <b-form-group v-show="post.locales.includes('ar')" class="col-md-12 mb-3 class_ar" label=" محتوى الخبر : ( عربي )" label-for="editor1" >
        <vueEditor id="editor1" ref="editor1" v-model="post.content_ar" />
      </b-form-group>
      <b-form-group v-show="post.locales.includes('en')" class="col-md-12 mb-3 class_en" label=" محتوى الخبر : ( انجليزي )" label-for="editor2" >
        <vueEditor id="editor2" ref="editor2" v-model="post.content_en" />
      </b-form-group>
      <b-form-group v-show="post.locales.includes('fa')" class="col-md-12 mb-3 class_fa" label=" محتوى الخبر : ( فارسي )" label-for="editor3" >
        <vueEditor id="editor3" ref="editor3" v-model="post.content_fa" />
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="الكلمات المفتاحية :" label-for="tag" >
        <input-tag class="form-control" placeholder="اضافة" :limit="limit" validate="" v-model="post.tags"></input-tag>
      </b-form-group>
    </div>

    <div class="mt-3">
      <hr>
      <b-button :disabled="loadingButton" @click="formAddPost(false)" variant="primary" type="button" class="me-2"> 
        <b-spinner v-if="loadingButton && !post.published" small></b-spinner>
        <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
      </b-button>

       <b-button :disabled="loadingButton" @click="formAddPost(true)" variant="success" type="button"> 
        <b-spinner v-if="loadingButton && post.published" small></b-spinner>
        <span v-else><i class="bx bx-paper-plane font-size-16 align-middle me-2"></i>نشر</span>
      </b-button>
    </div>
  </b-form>
</template>

